<template>
<modal v-if="showAssignmentModal" @close="closeAssigment" width="900" >
        <h3 class="mb-0" slot="header" v-if="professionals.length == 0">Nieuwe zoekopdracht plaatsen bij Azurity?</h3>
        <h3 class="mb-0" slot="header" v-else-if="professionals.length == 1">Een opdracht naar {{professionals[0].firstName}} sturen?</h3>
        <h3 class="mb-0" slot="header" v-else>Opdracht versturen naar meedere beveiligers?</h3>
        <div slot="body">
            <div class="alert alert-info" v-if="professionals.length == 0 && !isSuccess">
                <h5 class="alert-heading">Geen professional gevonden?</h5>
                <p class="mb-0">Door een opdracht bij Azurity te plaatsen gaan wij opzoek naar de juiste professional voor jouw klus.</p>
            </div>
            <hr v-if="professionals.length == 0">
            <div class="alert alert-success" v-if="isSuccess">
                <h5 class="alert-heading">Bedankt!</h5>
                <p class="mb-0">We hebben uw opdracht in goede orde ontvangen en sturen u nog een bevestigingsmail.</p>
            </div>
            <form v-else>
                <div class="form-row">
                    <div class="col-md-6">
                        <h5>De Opdracht</h5>
                        <div class="form-group">
                            <input :class="['form-control', ($v.assignment.title.$dirty) ? ($v.assignment.title.$error) ?'is-invalid' : 'is-valid' : '']" placeholder="Titel" v-model="assignment.title"  :disabled="isLoading"/>
                            <div class="invalid-feedback">
                                Titel van de opdracht is verplicht.
                            </div>
                        </div>
                        <div class="form-group">
                            <v-select label="name" :filterable="false" :options="$store.getters.cities" @search="onSearchCity" v-model="assignment.city" :class="['form-control', ($v.assignment.city.$dirty) ? ($v.assignment.city.$error) ?'is-invalid' : 'is-valid' : '']" placeholder="Plaats" name="city" id="city">
                                <template slot="no-options">
                                    Zoek een plaats...
                                </template>
                                <template slot="option" slot-scope="option" class="m-0 p-0">
                                    <div class="d-center m-0 p-0" >
                                        {{ option.name }}
                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        {{ option.name }}
                                    </div>
                                </template>
                            </v-select>
                            <div class="invalid-feedback">
                                Plaatsnaam is verplicht.
                            </div>
                        </div>
                        <div class="form-group">
                            <textarea :class="['form-control', ($v.assignment.description.$dirty) ? ($v.assignment.description.$error) ?'is-invalid' : 'is-valid' : '']" rows="9" placeholder="Opdrachtomschrijving"  v-model="assignment.description" :disabled="isLoading"></textarea>
                            <div class="invalid-feedback">
                                Opdrachtomschrijving is verplicht.
                            </div>
                        </div>
                        <div class="form-group">
                            <select :class="['form-control mb-3', ($v.assignment.skills.$dirty) ? ($v.assignment.skills.$error) ?'is-invalid' : 'is-valid' : '']" v-model="selectedAssignmentSkill" @change="addSkill" :disabled="isLoading">
                                <option value="-1">Selecteer vaardigheden...</option>
                                <optgroup>
                                    <option :value="s" v-for="s in $store.getters.skills" :key="s.id" >{{s.description}}</option>
                                </optgroup>
                            </select>
                            <div class="invalid-feedback">
                                U dient minimaal 1 vaardigheid op te geven.
                            </div>
                            <h5 v-for="p in assignment.skills" :key="p.skillId" @click="removeSkill(p)" class="badge-horizontal mr-2 inline">
                                <span class="badge badge-pill badge-secondary clickable">{{p.skill.description}}</span>
                            </h5>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group" v-if="professionals.length == 0">
                            <label class="form-label">Aantal Beveiligers</label>
                            <input :class="['form-control', ($v.assignment.professionalsQty.$dirty) ? ($v.assignment.professionalsQty.$error) ?'is-invalid' : 'is-valid' : '']" type="number" placeholder="Aantal Beveiligers?" v-model="assignment.professionalsQty" :disabled="isLoading" />
                            <div class="invalid-feedback">
                                Minimaal 1 beveiliger.
                            </div>
                        </div>
                        <h5>Planning</h5>
                        <div class="form-group" >
                            <div v-if="!group">
                                <multi-date-picker 
                                :class="['validate', ($v.assignment.dates.$dirty) ? ($v.assignment.dates.$error) ?'is-invalid' : 'is-valid' : '']" 
                                v-on:update="updateDates" 
                                :popoverDirection="$store.getters.isSmall ? 'top' : 'bottom'" 
                                :dates="assignment.dates.map((c) => { return c.date })" 
                                :disabled="isLoading"></multi-date-picker>
                                <div class="invalid-feedback">
                                    Datum(s) van uitvoering is verplicht.
                                </div>
                            </div>
                            <div class="table-responsive" v-if="!!assignment.dates && assignment.dates.length > 0">
                                <hr>
                                <table class="table table-sm" >
                                    <thead class="thead-azure-dark">
                                        <tr>
                                            <th>Datum</th>
                                            <th>Aanvang</th>
                                            <th>Duur (in uren)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(d, idx) in assignment.dates" :key="idx">
                                            <td class="pt-3">
                                                <strong>{{d.date.toLocaleDateString()}}</strong>
                                            </td>
                                            <td>
                                                <input :class="['form-control', ($v.assignment.dates.$each[idx.toString()].startTime.$dirty) ? ($v.assignment.dates.$each[idx.toString()].startTime.$error) ?'is-invalid' : 'is-valid' : '']" type="time" v-model="d.startTime"/>
                                                <div class="invalid-feedback">
                                                    Starttijd is verplicht.
                                                </div>
                                            </td>
                                            <td>
                                                <input :class="['form-control', ($v.assignment.dates.$each[idx.toString()].hours.$dirty) ? ($v.assignment.dates.$each[idx.toString()].hours.$error) ?'is-invalid' : 'is-valid' : '']" type="number" v-model="d.hours" />
                                                <div class="invalid-feedback">
                                                    Minimaal 1 uur.
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-12 text-center" v-if="professionals.length == 1 && !!assignment.hours">
                                <h4>Verwachte kosten*</h4>
                                <h2 class="mb-0">€ {{(assignment.hours * professionals[0].dayRate).toFixed(2)}}</h2>
                                <small>* op basis van normaal dagtarief.</small>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div slot="footer">
            <loader v-if="isLoading" width="2rem"></loader>
            <button class="btn btn-azure-dark" @click="saveAssignment" v-else-if="!isSuccess">Versturen</button>
        </div>
    </modal>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, maxLength, integer, minValue } from 'vuelidate/lib/validators'
import Modal from '@/components/Modal';
import Loader from '@/components/Loader';
import vSelect from 'vue-select';
import MultiDatePicker from '@/components/MultiDatePicker';
import { assignment, assignmentDate, assignmentUser } from '@/models/models.js';

const arrayNotEmpty = (value) => {
    return value.length > 0;
};
const greaterThanToday = (value, vm) => new Date(value) > new Date();

export default {
    name: 'assignment-modal',
    mixins: [validationMixin],
    props: {
        show: {
            required,
            type: Boolean,
            default: false
        }, 
        professionals: {
            type: Array,
            default: []
        }, 
        group: {
            required: false,
            type: Boolean,
            default: false
        }, 
    },
    components: {
        Modal,
        Loader,
        MultiDatePicker,
        vSelect
    },
    data() {
        return {
            isSuccess: false,
            isLoading: false,
            selectedAssignmentSkill: -1,
            showAssignmentModal: this.show,
            assignment: new assignment({ skills: [], dates: [], professionalsQty: this.professionals.length || 1 }),
            cities: []
        }
    },
    validations: {
        assignment: {
            title: {
                required,
                minLength: minLength(2),
                maxLength: maxLength(50),
            },
            description: {
                required,
                minLength: minLength(2),
                maxLength: maxLength(2000),
            },
            professionalsQty: {
                //requiredIf: requiredIf((a, vm) => { 
                    //debugger; 
                    //return this.professionals.length == 0
                //}),
                integer,
                //minValue: minValue(1)
            },
            city: {
                required
            },
            dates: {
                arrayNotEmpty,
                $each: {
                    date: {
                        required,
                    },
                    startTime: {
                        required
                    },
                    hours: {
                        required,
                        minValue: minValue(1)
                    }
                }
            },
            skills: {
                arrayNotEmpty
            }
        }
    },
    mounted() {
        this.$store.dispatch("GET_SKILLS");
    },
    methods: {
        onSearchCity(search, loading) {
            this.$store.dispatch('GET_CITIES', { search, loading });
        }, 
        addSkill() {
            const assignmentSkill = { 
                id: 0,
                skillId: this.selectedAssignmentSkill.id,
                skill: this.selectedAssignmentSkill
            };
            if(!this.assignment.skills.some((c) => { return c.skillId == assignmentSkill.skillId }) && !this.isLoading)
            {
                this.assignment.skills.push(assignmentSkill);
            }
            this.selectedAssignmentSkill = -1;
        },
        removeSkill(skill) {
            if(this.assignment.skills.indexOf(skill) >= 0 && !this.isLoading)
                this.assignment.skills.splice(this.assignment.skills.indexOf(skill), 1);
        },
        saveAssignment() {
            this.$v.assignment.$touch();
            if(!this.$v.$invalid)
            {
                this.isLoading = true;
                if(this.professionals.length > 0 && this.assignment.assignmentUsers.length == 0)
                {
                    this.professionals.forEach((p) => {
                        this.assignment.assignmentUsers.push(p);
                    });
                    this.assignment.professionalsQty = this.assignment.assignmentUsers.length;
                }

                var a = JSON.parse(JSON.stringify(this.assignment));
                //a.dates = a.dates.map(d => { return { date: d }});

                this.$http.post('api/Assignments', a).then(() => {
                    this.isSuccess = true;
                    this.isLoading = false;
                    this.assignment = new assignment({ skills: [], dates: [], professionalsQty: this.professionals.length || 1 });
                }).catch(() => {
                    this.isLoading = false;
                    alert("Oops, er is iets fout gegaan, probeer nogmaals.")
                });
            }
        },
        closeAssigment() {
            //this.showAssignmentModal = false;
            this.$emit('close');
            if(this.isSuccess)
                this.assignment = new assignment({ skills: [] });
            this.isSuccess = false;
        },
        updateDates(dates) {
            let profs = this.professionals.map((p) => { return { applicationUserId: p.applicationUserId } });

            return this.assignment.dates = dates.map((d) => {
                return new assignmentDate({
                    date: d,
                    startTime: '09:00',
                    hours: 8,
                    actualHours: 1,
                    assignmentUsers: profs
                })
            });
        }
    },
    watch:
    {
        professionals(value) {
            if(this.professionals.length > 0)
            {
                this.assignment.professionalsQty = 1;
                this.assignment.dates = [];
                this.assignment.skills = [];
                this.assignment.assignmentUsers = [];

                this.professionals.forEach((p) => {
                    this.assignment.assignmentUsers.push({
                        applicationUserId: p.applicationUserId,
                        assignmentId: this.assignment.id,
                        assignmentStatusId: 1,
                        hours: this.assignment.hours,
                        rates: p.availableDates.map((d) => {
                            return {
                                date: d
                            };
                        })
                    });

                    p.availableDates.forEach((s) => {
                        if(!this.assignment.dates.some((c) => { return c.date == new Date(s) }))
                        {
                            this.assignment.dates.push({
                                date: new Date(s),
                                startTime: '09:00',
                                hours: 8
                            });
                        }
                    });
                });
            } else {
                this.assignment.professionalsQty = null;
                this.assignment.skills = [];
                this.assignment.dates = [];
            }
        },
        show(value) {
            this.showAssignmentModal = value;
        }
    }
}
</script>

<style scoped>
.is-invalid + .invalid-feedback {
    display: block;
}

</style>